import { HeroHistoryStatus, CosmeticSource } from '@profile/src/models';
import { CosmeticType } from '@profile/src/utils/types';
export const parseCosmeticType = type => {
  if (!type) {
    return '';
  }

  switch (type) {
    case CosmeticType.AVATAR:
      {
        return 'Avatar';
      }

    case CosmeticType.AVATAR_FRAME:
      {
        return 'Avatar Frame';
      }

    case CosmeticType.EMOTE:
      {
        return 'Emote';
      }

    case CosmeticType.SPACESHIP:
      {
        return 'SpaceShip';
      }

    default:
      {
        return '';
      }
  }
};
export const formatStatus = status => {
  switch (status) {
    case HeroHistoryStatus.SUCCESS:
      return {
        displayName: 'Completed',
        style: 'completed'
      };

    case HeroHistoryStatus.PROCESSING:
      return {
        displayName: 'Processing',
        style: 'processing'
      };

    case HeroHistoryStatus.FAILED:
      return {
        displayName: 'Cancelled',
        style: 'cancelled'
      };

    default:
      return undefined;
  }
};
export const formatType = status => {
  switch (status) {
    case CosmeticSource.OPEN_BOX:
      return 'Open Box';

    case CosmeticSource.SEASON_END:
      return 'Season End';

    case CosmeticSource.SOLD:
      return 'Sold';

    case CosmeticSource.PURCHASE:
      return 'Purchase';

    case CosmeticSource.RANKING_REWARD:
      return 'Ranking Reward';

    case CosmeticSource.MINT:
      return 'Mint';

    case CosmeticSource.WHEEL_REWARD:
      return 'Giftmas Fortune Wheel';

    default:
      return '';
  }
};